import { useState } from 'react';
import CategoryTabs from './CategoryTabs';
import PartSelector from './PartSelector';
import styles from './ConfigPanel.module.css';

export default function ConfigPanel() {
    const [activeCategory, setActiveCategory] = useState('trim');

    return (
        <div className={styles.panel}>
            <CategoryTabs
                activeCategory={activeCategory}
                onSelectCategory={setActiveCategory}
            />
            <div className={styles.content}>
                <PartSelector category={activeCategory} />
            </div>
        </div>
    );
}
